export default __webpack_public_path__ + "static/usi-avatar-5efc82752a5614a9a2adc9fd40f11833.png";